import type { NostrEvent } from '@nostrify/nostrify';

/** NIP-54 wiki article (addressable). */
export const WIKI_ARTICLE_KIND = 30818;
/** NIP-54 wiki redirect (addressable). */
export const WIKI_REDIRECT_KIND = 30819;
/** NIP-54 merge request (regular). */
export const WIKI_MERGE_REQUEST_KIND = 818;

export function getTagValue(event: NostrEvent, name: string): string | undefined {
  return event.tags.find(([n]) => n === name)?.[1];
}

/** A wiki article must have a non-empty `d` tag. Title/summary are optional per NIP-54. */
export function isValidWikiArticle(event: NostrEvent): boolean {
  if (event.kind !== WIKI_ARTICLE_KIND) return false;
  const d = getTagValue(event, 'd');
  return Boolean(d && d.trim().length > 0);
}

/** A wiki redirect must have a `d` tag and an `a` tag pointing to the target article. */
export function isValidWikiRedirect(event: NostrEvent): boolean {
  if (event.kind !== WIKI_REDIRECT_KIND) return false;
  const d = getTagValue(event, 'd');
  const a = getTagValue(event, 'a');
  return Boolean(d && a);
}

export interface AddressPointer {
  kind: number;
  pubkey: string;
  identifier: string;
}

/** Parses an `a` tag value (`kind:pubkey:identifier`) into its parts. */
export function parseAddressPointer(value: string): AddressPointer | undefined {
  const [kindStr, pubkey, ...rest] = value.split(':');
  const kind = Number(kindStr);
  if (!Number.isFinite(kind) || !pubkey) return undefined;
  return { kind, pubkey, identifier: rest.join(':') };
}

export function articleTitle(event: NostrEvent): string {
  return getTagValue(event, 'title') || getTagValue(event, 'd') || 'Untitled';
}

export function articleSummary(event: NostrEvent): string | undefined {
  return getTagValue(event, 'summary');
}
